import config from 'config'

const FanXStockTypeService = {
    electronic: {
        noun: 'Email Delivery ticket',
        nounPlural: 'Email Delivery tickets'
    },
    hard: {
        noun: 'Hard ticket',
        nounPlural: 'Hard tickets'
    },
    instant: {
        noun: 'Instant Delivery ticket',
        nounPlural: 'Instant Delivery tickets'
    },
    flash: {
        noun: 'Flash Seat ticket',
        nounPlural: 'Flash Seat tickets'
    },
    paperless: {
        noun: 'Paperless ticket',
        nounPlural: 'Paperless tickets'
    },
    paperlesswalkin: {
        noun: 'Paperless walk-in ticket',
        nounPlural: 'Paperless walk-in tickets'
    },
    mobile: {
        noun: 'Mobile ticket',
        nounPlural: 'Mobile tickets'
    }
}

const VividSeatsStockTypeService = {
    "e-tickets": {
        noun: 'Print at Home',
        nounPlural: 'Print at Home'
    },
    "e-tickets-instant": {
        noun: 'Print at Home - Instant Delivery',
        nounPlural: 'Print at Home - Instant Delivery'
    },
    hard: {
        noun: 'Local pickup',
        nounPlural: 'Local pickup'
    },
    'hard-couriered': {
        noun: 'Shipped via UPS',
        nounPlural: 'Shipped via UPS'
    },
    instant: {
        noun: 'Instant Delivery ticket',
        nounPlural: 'Instant Delivery tickets'
    },
    flash: {
        noun: 'AXS Mobile ID (formerly Flash Seats®) ticket',
        nounPlural: 'AXS Mobile ID (formerly Flash Seats®) tickets'
    },
    'flash-instant': {
        noun: 'AXS Mobile ID (formerly Flash Seats®) – Instant delivery ticket',
        nounPlural: 'AXS Mobile ID (formerly Flash Seats®) – Instant delivery tickets'
    },
    "paperless card": {
        noun: 'Local Pickup',
        nounPlural: 'Local Pickup'
    },
    "paperless card-couriered": {
        noun: 'Shipped by UPS',
        nounPlural: 'Shipped by UPS'
    },
    "paperless walk-in": {
        noun: 'Local Pickup',
        nounPlural: 'Local Pickup'
    },
    'ticketmaster transfer': {  // non-instant electronic transfer
        noun: 'Mobile Ticket',
        nounPlural: 'Mobile Tickets'
    },
    'ticketmaster transfer-texted': {  // delivered via text msg link
        noun: 'Electronic Transfer',
        nounPlural: 'Electronic Transfers'
    },
    'ticketmaster transfer-instant': {
        noun: 'Mobile Ticket - Instant Delivery',
        nounPlural: 'Mobile Tickets - Instant Delivery'
    },
    'mobile screencap': {
        noun: 'Straight to Your Pocket',
        nounPlural: 'Straight to Your Pocket',
    },
    'mobile screencap-instant': {
        noun: 'Straight to Your Pocket - instant delivery',
        nounPlural: 'Straight to Your Pocket - instant delivery',
    },
}

let fxFormat = function (key, quantity) {
    const stockType = FanXStockTypeService[key]
    if (stockType === FanXStockTypeService.paperlesswalkin || stockType === FanXStockTypeService.hard || stockType === FanXStockTypeService.paperless) {
        return ''
    }
    return (quantity === 1) ? stockType.noun : stockType.nounPlural
}

let vsFormat = function (key, quantity) {
    const stockType = VividSeatsStockTypeService[key]
    if (stockType === VividSeatsStockTypeService.paperlesswalkin || stockType === VividSeatsStockTypeService.paperless) {
        return ''
    }
    return (quantity === 1) ? stockType.noun : stockType.nounPlural
}

const format = (config.isIntegrated) ? vsFormat : fxFormat
function install (Vue) {
    Vue.filter('stockType', format)
    Vue.prototype.$formatStockType = (config.isIntegrated) ? vsFormat : fxFormat
}

export default {
    format,
    install
}
